<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex xs12 md12>
        <h3>{{ chapterDetail.name }} <small> | code: {{ chapterDetail.code }}</small> </h3>
        <span>{{ chapterDetail.courses ? chapterDetail.courses.name : '' }}, </span>
        <span>{{ chapterDetail.subjects ? chapterDetail.subjects.name : '' }}</span>
      </v-flex>
      <v-flex xs12 md8>
        <v-dialog v-model="dialog" width="1000" hegiht="auto" >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Upload Lecture 
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
            <FormLecture
              :ProgressBar="uploadPercentage"
              :DisableButton="disableButton"
              :Item="lectureItem"
              :Value="lectureValueObj"
              @emitted="submitLectureVideo"
              />
         

          </v-card>
        </v-dialog>
        <material-card
        
          color="green"
          title="Lecture List"
          text=""
        >

          <v-data-table
            :headers="headers"
            :items="lectureList"
            color="green"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> <router-link :to="'/lecture-details/' + item.id"> {{ item.title }}</router-link></td>
              <td> <router-link :to="'/lecture-details/' + item.id"> {{ item.title_bn }}</router-link></td>
              <!-- <td>{{ item.description }}</td> -->
              <td>{{ item.url }}</td>
              <td>{{ item.sequence }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.tutor_name }}</td>
              <td>{{ item.youtube_video_id }}</td>
              <td>
                
                    <v-btn color="danger" fab small dark round @click="deleteLecture(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                
                    <v-btn color="success" fab small dark round @click="editLecture(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
            </template>
          </v-data-table>
 
        <v-dialog v-model="dialogDeleteLecture" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
            
      
          </template>

          <v-card>
            
          <v-container>
            <material-card
              :title="'Delete'"
              color="red"> 
            <v-flex
              xs12>
              You are going to delete {{  deleteItem.title }}
              <h3>
                Are you sure!!
              </h3>
            </v-flex>
            </material-card>
            <v-flex
              xs12
              text-xs-right>
              <v-btn @click="deleteVideo"
                class="mx-0 font-weight-light"
                color="success" >Yes</v-btn>
              <v-btn @click="closeDeleteDialog"
                class="mx-2 font-weight-light"
                color="info">No</v-btn>
                
            </v-flex> 
          </v-container>
          </v-card>
        </v-dialog>
          
        </material-card>

        <v-dialog v-model="dialogEditLecture" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
              
          </template>
          <v-card>
            <EditFormLecture
              :Item="lectureEditItem"
              :Value="lectureObj"
              @emitted="updateLectureForm"
              @closed="closeModal"
              />

          </v-card>
        </v-dialog>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>{{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
   
           <ChapterScript />
           <ChapterExam />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormLecture from '@/views/FormLecture'
import FormScript from '@/views/FormScript'
import ChapterScript from '@/views/ChapterScript'
import ChapterExam from '@/views/ChapterExam'
import Form from '@/views/Form'
import EditFormLecture from '@/views/EditFormLecture'
export default {
  components: {
    Form,
    FormLecture,
    ChapterScript,
    ChapterExam,
    EditFormLecture,
    FormScript
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('lectures', ['lectureList', "chapterDetail", 'scriptList',
      'uploadPercentage'
      ]),
  },
  mounted () {
    this.getChapterDetailsChapterId(this.$route.params.id)
    this.getScriptlistByChapterId(this.$route.params.id)
    this.getLectureListByChapterId(this.$route.params.id)
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    lectureItem: {
      'title': 'Add new Lecture Video',
      'subTitle': 'This is the subtitle',
      'width': 'md6',
      'submitText' : 'Submit'
    },
    
    lectureEditItem: {
      'title': 'EditLecture Video',
      'width': 'md6',
      'submitText' : 'Update'
    },
    
      
    disableButton: false,
    lectureValueObj: {},
    lectureObj: {},
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    dialogDeleteLecture: false,
    dialogEditLecture: false,
    deleteItem: {},
    headers: [
      {
        sortable: true,
        text: 'Title',
        value: 'title'
      },
      {
        sortable: true,
        text: 'Title Bangla',
        value: 'title_bn'
      },
      {
        sortable: false,
        text: 'File',
        value: 'url'
      },
      // {
      //   sortable: false,
      //   text: 'Description',
      //   value: 'description'
      // },,
      {
        sortable: true,
        text: 'Sequence',
        value: 'sequence'
      },
      {
        sortable: true,
        text: 'Price',
        value: 'price'
      },
      {
        sortable: true,
        text: 'Tutor',
        value: 'tutor_name'
      },
      {
        sortable: false,
        text: 'Ytube ID',
        value: 'youtube_video_id'
      },
      {
        sortable: false,
        text: 'Action'
      },
    ],
    
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'Add new Lecture Video',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: {
        'chapter_id' : this.$route.params.id,
        'course_id' : this.$route.params.courseId,
        'subject_id' : this.$route.params.subjectId
       },
    }
  },
  created () {
    // this.$store.action
  },

  methods: {
    ...mapActions("lectures", ["getLectureListByChapterId", 'getScriptlistByChapterId', 'storeChapterScript',
      "getChapterDetailsChapterId", 'storeLectureVideo', 'deleteLectureVideo', 'updateLectureVideo']),

     submitLectureVideo (data) {
      this.disableButton = true
  
      this.storeLectureVideo(data).then((response) => {
        if (response.status == 'OK') {
          this.dialog = false
          this.disableButton = false
          this.$store.state.course_subjects.lecture_videoList.push(response.result)
          this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
          this.dialog = false
          this.disableButton = false
        }
      }).catch((err) => {
        console.log(err)
      })
    },
 
    editLecture (item) {
      this.lectureObj = item
      this.dialogEditLecture = true
    },

    updateLectureForm (value) {
      this.updateLectureVideo(value).then((response) => {
        if (response.status == 'OK') {
          this.getLectureListByChapterId(this.$route.params.id)
          this.dialogEditLecture = false
          this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.color= 'warning'
          this.noticeMessage = response.messages
          this.snack('top')
        }
      })
    },
    deleteLecture (item) {
      this.deleteItem = item
      this.dialogDeleteLecture = true
    },
    closeModal () {
      this.dialogEditLecture = false
    },

    deleteVideo () {
      this.deleteLectureVideo({id: this.deleteItem.id}).then((response) => {
        if (response.status == 'OK') {
          this.getLectureListByChapterId(this.$route.params.id)
          this.dialogDeleteLecture = false
          this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.color= 'warning'
          this.noticeMessage = response.messages
          this.snack('top')
        }
      })
    },
    closeDeleteDialog () {
      this.dialogDeleteLecture = false
    },
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }


      this.snackbar = true
    }
  }
}
</script>
<style scoped>
.v-btn--floating.v-btn--small {
    width: 40px;
}
</style>